import { render, staticRenderFns } from "./Course-card.vue?vue&type=template&id=418c92a0&scoped=true"
import script from "./Course-card.vue?vue&type=script&lang=js"
export * from "./Course-card.vue?vue&type=script&lang=js"
import style0 from "./Course-card.vue?vue&type=style&index=0&id=418c92a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c92a0",
  null
  
)

export default component.exports